import {Component} from '@angular/core';
import {NavController, NavParams, PopoverController, ViewController} from 'ionic-angular';

/**
 * Generated class for the VorlageneditorInspectionpointDetailsNewReviewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vorlageneditor-inspectionpoint-details-new-review',
  templateUrl: 'vorlageneditor-inspectionpoint-details-new-review.html',
})
export class VorlageneditorInspectionpointDetailsNewReviewPage {

  public newReview: { title: string, color: string, danger: number } = {title: null, color: '#8d8d8d', danger: 0};
  public isNew: boolean = false;


  private reviews: Array<Object>;


  constructor(public navCtrl: NavController, public navParams: NavParams, private popoverCtrl: PopoverController) {
    this.reviews = this.navParams.get('reviews');
    this.isNew = this.navParams.get('isNew');

    if (!this.isNew) {
      this.newReview = this.navParams.get('review');
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VorlageneditorInspectionpointDetailsNewReviewPage');
  }

  public addReview(): void {
    this.reviews.push(this.newReview);
    this.navCtrl.pop();
  }

  public showAvailableColors($event) {
    let colorChooserPopover = this.popoverCtrl.create(PopoverColorChooser);
    colorChooserPopover.present({
      ev: $event
    });
    colorChooserPopover.onDidDismiss((data) => {
      if (data) {
        this.newReview.color = data;
      }
    })
  }

}

@Component({
  template: `
    <ion-list>
      <ion-list-header text-center>Farbe auswählen</ion-list-header>
      <ion-item [style.background-color]="color" (click)="close(color)" *ngFor="let color of colors"></ion-item>
    </ion-list>
  `
})
export class PopoverColorChooser {

  public colors: Array<string> = [
    '#ff0000',
    '#f44236',
    '#ea1e63',
    '#9c28b1',
    '#673bb7',
    '#3f51b5',
    '#2196f3',
    '#03a9f5',
    '#00bcd5',
    '#009788',
    '#008000',
    '#4db151',
    '#8bc24a',
    '#cddc39',
    '#ffeb3c',
    '#fec107',
    '#ff9700',
    '#fe5722',
    '#795547',
    '#9e9e9e',
    '#607d8b',
  ];

  constructor(public viewCtrl: ViewController) {
  }

  close(color) {
    this.viewCtrl.dismiss(color, null, {animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/pages/vorlageneditor-inspectionpoint-details-new-review/vorlageneditor-inspectionpoint-details-new-review.ts